<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full" style="background-color: #262d4a">
    <div class="vx-col sm:w-1/2 md:w-2/5 lg:w-2/5 xl:w-1/4 mx-auto self-center">
      <img style="width:100%;" :src="siteLogoUrl"/>
      <vx-card card-background="#11193f" class="glow-effect_white my-4">
        <span class="text-center" style="color: rgb(255, 255, 255); font-family: Montserrat;font-size: 16pt;"><p>You have been successfully&nbsp;</p><p style="font-weight: 600; ">unsubscribed!</p></span>
      </vx-card>

      <div class="mt-4" style="text-align: center;"><span style="color: lightgray">COPYRIGHT @ {{ new Date().getFullYear() }} <a style="color: #52b75d" >DigiCampus v2.0</a> | Powered by DigiCentral.co.za</span></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    siteLogoUrl: function() {
      return 'https://lateralscaffolding.blob.core.windows.net/resources/digicentral-logo.png';
    },
  },
  methods: {
    unsubscribe() {
      const self = this;
      
      self.$ajaxGetAnon(self, `unsubscribe?email=${self.$route.query.email}`);
    },
  },
  mounted() {
    this.unsubscribe();
  },
  beforeCreate() {
    var self = this;
    document.title = "DigiCentral | Unsubscribed";
    this.$setSchoolTheme();
    this.$setColors();
  }
};
</script>
